/**
 * English mirror of ./strings.ar.js — GENERATED by scripts/i18n/build.mjs.
 *
 * Wording follows the legacy Locale/*.resx English resources wherever the
 * legacy screen had the same label. To change any of it, edit
 * scripts/i18n/strings.en.json and re-run the script.
 */

export const strings = {
  actionFailed: 'The operation could not be completed',
  title: 'Personal Reports',
  errorHeading: 'Error Message',
  errorBody: 'Error processing current request or user is not found',

  tabs: {
    attributes: 'User Details',
    activities: 'User Activities',
    statusLogs: 'User Status Log',
    policies: 'User Policies Details',
    programs: 'Program Summary',
    examTries: 'Reset Exam Counter',
    phishing: 'Phishing Report',
    securityReports: 'Security Reports',
    assessments: 'Assessments',
    surveys: 'Program Survey',
    points: 'Points & Levels',
    pointsLog: 'Transactions',
  },

  profile: {
    arabicName: 'Arabic Name',
    englishName: 'English Name',
    loginProvider: 'Login method',
    profileUpdateStatus: 'Profile update status',
    updated: 'Updated',
    notUpdated: 'Not updated',
    termsStatus: 'Terms of use acceptance',
    agreed: 'Is Accepted',
    notAgreed: 'Not Acknowledged',
    license: 'License',
    startDate: 'Start Date',
    manualStatus: 'User manual viewed',
    viewed: 'Viewed',
    notViewed: 'Not viewed',
    email: 'Email Address',
    lastLogin: 'Last Login Date',
    sendEmail: 'Send Email',
  },

  standing: {
    badges: 'Badges',
    noRisk: 'None',
  },

  activities: {
    name: 'Activity Name',
    date: 'Activity Date',
    details: 'Details',
  },

  statusLogs: {
    status: 'Status',
    date: 'Date',
    notes: 'Notes',

    values: {
      '0': 'Active',
      '1': 'Resigned',
      '2': 'Awaiting resignation approval',
      '3': 'Suspended',
      '4': 'Awaiting activation',
      '5': 'Expired',
    },
  },

  policies: {
    title: 'Policy',
    isDownloaded: 'Is Downloaded',
    downloadDate: 'Last Download Date',
    status: 'Status',
    statusDate: 'Last Status Date',
    yes: 'Yes',
    no: 'No',
    accepted: 'Is Accepted',
    notAccepted: 'Not Acknowledged',
  },

  securityReports: {
    index: 'ID',
    id: 'Report Number',
    title: 'Report Title',
    category: 'Category',
    createdOn: 'Creation Date',
    lastUpdate: 'Last Updated',
    state: 'Report State',

    states: {
      '0': 'New',
      '1': 'In Progress',
      '2': 'Closed (valid report)',
      '3': 'Cancelled (false report)',
    },
  },

  examTries: {
    resetDone: 'Reset successfully',
    exam: 'Test',
    allowed: 'Allowed Tries',
    used: 'User Tries',
    reset: 'Reset',
  },

  points: {
    positive: 'Positive Points',
    negative: 'Negative Points',
    riskLevel: 'Risk Level',
    badges: 'Badges',
    description:
      'Learners earn rewards for key activities — watching courses, passing exams and reading policies.\\nPoints, badges and achievements are granted automatically as they progress.\\nThese incentives lift engagement and encourage continuous learning.',
  },

  pointsLog: {
    activity: 'Activity name',
    date: 'Date',
    points: 'Points',
    percentage: 'Percentage On Duplication',
    type: 'Points Type',
    opposite: 'Effect Opposite?',
  },

  programs: {
    summary: 'Program Summary',
    programsCount: 'Programs',
    coursesCount: 'Courses',
    successPercentage: 'Success Percentage',

    successOf: 'Success rate out of',
    watchHint: 'Average watched per course',

    watchPercentage: 'Watching Percentage',
    title: 'Program',
    state: 'Status',
    details: 'Details',
    states: { 0: 'Completed', 1: 'In progress', 2: 'Not started' },
    noPrograms: 'This user is not enrolled in any programme',
  },

  courses: {
    title: 'Courses Summary',
    name: 'Course',
    startDate: 'Start Date',
    endDate: 'End Date',
    state: 'Exam State',
    percentage: 'Degree',
    tries: 'Exam Tries',
    watchState: 'Watch State',
    states: { passed: 'Passed', failed: 'Failed' },
    noExam: 'No exam',
  },

  exams: {
    title: 'User Tests',
    name: 'Exam Name',
    course: 'Course',
    date: 'Exam Date',
    percentage: 'Degree',
    state: 'Exam State',
    noExams: 'This course has no exam',
    back: 'Back to courses',
  },

  phishing: {
    campaign: 'Name',
    status: 'Status',
    reportingDate: 'Reporting Date',
    details: 'Details',
    timeline: 'Campaign trail',

    /* PhishingUserStatus is -1..4, NOT 0..5 — the transcription from
       PhishingTable.cshtml read the enum MEMBERS as literals and shifted every
       label by one, so a recipient who submitted credentials (3) was labelled
       "clicked a link". API_FINDINGS.md §54. */
    states: {
      '-1': 'Scheduled', // PhishingUserStatus.Scheduled
      '0': 'Email Sent', // PhishingUserStatus.Sent
      '1': 'Email Opened', // PhishingUserStatus.EmailOpened
      '2': 'Link Clicked', // PhishingUserStatus.LinkClicked
      '3': 'Data Submitted', // PhishingUserStatus.DataSubmitted
      '4': 'Reported', // PhishingUserStatus.UserReported
    },
  },

  assessments: {
    index: 'ID',
    title: 'Title',
    state: 'Status',
    mandatory: 'Mandatory',
    score: 'Score',
    completedOn: 'Taken On',
  },

  surveys: {
    index: 'ID',
    title: 'Title',
    createdOn: 'Creation Date',
    mandatory: 'Mandatory',
    state: 'Status',
    download: 'Download Details',
    answered: 'Answered',
    notAnswered: 'Not Answered',
    notAnsweredHint: 'This survey does not have any answers by the user',
    downloaded: 'Operation Completed Successfully',
  },

  yes: 'Yes',
  no: 'No',
  mandatory: 'Mandatory',
  optional: 'Optional',

  exportExcel: 'Export to Excel',
  exportPdf: 'Export to PDF',
  exportFailed: 'The file could not be exported, please try again',
  close: 'Close',
}
